export default __webpack_public_path__ + "static/media/menu.874cb8be.svg";